/** Shared motion tokens so every animation shares one rhythm and feel. */

export const easing = {
  standard: [0.22, 1, 0.36, 1],
  entrance: [0.16, 1, 0.3, 1],
  exit: [0.7, 0, 0.84, 0],
  gentle: [0.25, 0.1, 0.25, 1],
} as const;

export const duration = {
  micro: 0.18,
  standard: 0.35,
  section: 0.6,
  cinematic: 1.1,
} as const;

/** Default viewport for scroll-reveal: fire once, a little before fully in view. */
export const revealViewport = { once: true, margin: '-80px' } as const;
